import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

export type ProductRef = {
    productId: number;
    productName: string;
    expiryISO: string; // "2025-11-02" o ISO
};

export async function scheduleOneExpiryLocal({ productId, productName, expiryISO }: ProductRef) {
    if (Capacitor.getPlatform() === 'web') return false;
    try {
        const perm = await LocalNotifications.checkPermissions();
        if (perm.display !== 'granted') {
            const req = await LocalNotifications.requestPermissions();
            if (req.display !== 'granted') return false;
        }

        const expiry = new Date(expiryISO);
        if (isNaN(expiry.getTime())) return false;

        const fireDate = new Date(expiry);
        fireDate.setDate(expiry.getDate() - 15);
        fireDate.setHours(10, 0, 0, 0); // 10:00 local

        if (fireDate.getTime() <= Date.now()) return false;

        const id = Number(`${productId}15`);
        await LocalNotifications.schedule({
            notifications: [{
            id,
            title: 'Tu producto caduca pronto',
            body: `${productName} caduca el ${expiry.toLocaleDateString('es-ES')}`,
            schedule: { at: fireDate, allowWhileIdle: true },
            extra: { type: 'expiry_local', productId: String(productId) },
            }],
        });
        return true;
    } catch (e) {
        console.warn('LocalNotifications not available:', e);
        return false;
    }
}

export async function scheduleManyExpiryLocal(items: ProductRef[]) {
    for (const it of items) await scheduleOneExpiryLocal(it);
}

export async function cancelExpiryLocal(productId: number) {
    await LocalNotifications.cancel({ notifications: [{ id: Number(`${productId}15`) }] });
}

export async function cancelAllExpiryLocals() {
    const pending = await LocalNotifications.getPending();
    if (pending.notifications.length) {
        await LocalNotifications.cancel({ notifications: pending.notifications.map(n => ({ id: n.id })) });
    }
}

/** Reprograma: cancela la existente y crea la nueva con la nueva fecha. */
export async function rescheduleExpiryLocal(p: ProductRef) {
    await cancelExpiryLocal(p.productId);
    return scheduleOneExpiryLocal(p);
}

/** Botón de prueba: dispara una local en 30 s para este producto. */
export async function scheduleTestLocal(productId: number, productName: string) {
    const perm = await LocalNotifications.checkPermissions();
    if (perm.display !== 'granted') {
        const req = await LocalNotifications.requestPermissions();
        if (req.display !== 'granted') return false;
    }
    const id = Number(`${productId}999`); // id distinto para la prueba
    const in30s = new Date(Date.now() + 30 * 1000);
    await LocalNotifications.schedule({
        notifications: [{
        id,
        title: 'Prueba de notificación',
        body: `Esto es una prueba para ${productName}.`,
        schedule: { at: in30s, allowWhileIdle: true },
        extra: { type: 'expiry_local_test', productId: String(productId) },
        }],
    });
    return true;
}
